import { createAction, props } from '@ngrx/store';
import { GMServiceVisitDtcCount } from 'libs/models/oem-resource/gm/service-visit-dtc-count.model';
import { GMServiceVisitDtc } from 'libs/models/oem-resource/gm/service-visit-dtc.model';
import { GMServiceVisitVehicleData } from 'libs/models/oem-resource/gm/service-visit-vehicle-data.model';
import { SvcVehicleDiagnosticsRootEntity } from './svc-vehicle-diagnostics-root.models';
import { GMServiceVisitByDealerQueryParameters, GMServiceVisitByVinQueryParameters } from '@quorum/models/oem-query';
import { GMServiceVisitByDealer, GMServiceVisitByVin } from '@quorum/models/oem-resource';

export enum SvcVehicleDiagnosticsRoot {
  getGMServiceVisitByVin = '[svcVehicleDiagnostics] Get GM Service Visit By Vin',
  getGMServiceVisitByVinError = '[svcVehicleDiagnostics] Get GM Service Visit By Vin Error',
  getGMServiceVisitByVinSuccess = '[svcVehicleDiagnostics] Get GM Service Visit By Vin Success',
  getGMServiceVisitByDealer = '[svcVehicleDiagnostics] Get GM Service Visit By Dealer',
  getGMServiceVisitByDealerError = '[svcVehicleDiagnostics] Get GM Service Visit By Dealer Error',
  getGMServiceVisitByDealerSuccess = '[svcVehicleDiagnostics] Get GM Service Visit By Dealer Success',
  getLinkedServiceVisitDtc = '[svcVehicleDiagnostics] Get Linked Service Visit DTC',
  getLinkedServiceVisitDtcError = '[svcVehicleDiagnostics] Get Linked Service Visit DTC Error',
  getLinkedServiceVisitDtcSuccess = '[svcVehicleDiagnostics] Get Linked Service Visit DTC Success',
  getLinkedServiceVisitMpvi = '[svcVehicleDiagnostics] Get Linked Service Visit MPVI',
  getLinkedServiceVisitMpviError = '[svcVehicleDiagnostics] Get Linked Service Visit MPVI Error',
  getLinkedServiceVisitMpviSuccess = '[svcVehicleDiagnostics] Get Linked Service Visit MPVI Success',
  getLinkedServiceVisitEcu = '[svcVehicleDiagnostics] Get Linked Service Visit ECU',
  getLinkedServiceVisitEcuError = '[svcVehicleDiagnostics] Get Linked Service Visit ECU Error',
  getLinkedServiceVisitEcuSuccess = '[svcVehicleDiagnostics] Get Linked Service Visit ECU Success',
  updateLinkedServiceVisitInState = '[svcVehicleDiagnostics] Update Linked Service Visit In State',
  clearLinkedServiceVisitState = '[svcVehicleDiagnostics] Clear Linked Service Visit State',
  clearVehicleDiagnosticsState = '[svcVehicleDiagnostics] Clear Vehicle Diagnostics State',
}

export const init = createAction('[SvcVehicleDiagnosticsRoot Page] Init');

export const loadSvcVehicleDiagnosticsRootSuccess = createAction(
  '[SvcVehicleDiagnosticsRoot/API] Load SvcVehicleDiagnosticsRoot Success',
  props<{ svcVehicleDiagnosticsRoot: SvcVehicleDiagnosticsRootEntity[] }>()
);

export const loadSvcVehicleDiagnosticsRootFailure = createAction(
  '[SvcVehicleDiagnosticsRoot/API] Load SvcVehicleDiagnosticsRoot Failure',
  props<{ error: any }>()
);

//Regions in Actions for each OEM
//Three level state VehicleDiagnostics - OEM - entityState

//#region GM
export const getGMServiceVisitByVin = createAction(
  '[svcVehicleDiagnostics] Get GM Service Visit By Vin',
  props<{
    businessId: string;
    dealerCountryCode: string;
    vin: string;
    queryParameters?: GMServiceVisitByVinQueryParameters;
  }>()
);

export const getGMServiceVisitByVinError = createAction(
  '[svcVehicleDiagnostics] Get GM Service Visit By Vin Error',
  props<{
    businessId: string;
    dealerCountryCode: string;
    vin: string;
    queryParameters?: GMServiceVisitByVinQueryParameters;
    error: any;
  }>()
);

export const getGMServiceVisitByVinSuccess = createAction(
  '[svcVehicleDiagnostics] Get GM Service Visit By Vin Success',
  props<{ businessId: string; dealerCountryCode: string; serviceVisits: GMServiceVisitByVin[] }>()
);

export const getGMServiceVisitByDealer = createAction(
  '[svcVehicleDiagnostics] Get GM Service Visit By Dealer',
  props<{
    businessId: string;
    dealerCountryCode: string;
    startDate: string;
    endDate: string;
    bac: string;
    queryParameters?: GMServiceVisitByDealerQueryParameters;
  }>()
);

export const getGMServiceVisitByDealerError = createAction(
  '[svcVehicleDiagnostics] Get GM Service Visit By Dealer Error',
  props<{
    businessId: string;
    dealerCountryCode: string;
    startDate: string;
    endDate: string;
    bac: string;
    queryParameters?: GMServiceVisitByDealerQueryParameters;
    error: any;
  }>()
);

export const getGMServiceVisitByDealerSuccess = createAction(
  '[svcVehicleDiagnostics] Get GM Service Visit By Dealer Success',
  props<{
    businessId: string;
    dealerCountryCode: string;
    startDate: string;
    endDate: string;
    bac: string;
    serviceVisits: GMServiceVisitByDealer[];
  }>()
);

export const updateLinkedServiceVisitInState = createAction(
  '[svcVehicleDiagnostics] Update Linked Service Visit In State',
  props<{ serviceVisitId: string; preserveAdvisorOdometer?: boolean }>()
);

export const getLinkedServiceVisitDtc = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit DTC',
  props<{ businessId: string; dealerCountryCode: string; serviceVisitId: string }>()
);

export const getLinkedServiceVisitDtcError = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit DTC Error',
  props<{ error: any }>()
);

export const getLinkedServiceVisitDtcSuccess = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit DTC Success',
  props<{ linkedServiceVisitDtc: GMServiceVisitDtc[] }>()
);

export const getLinkedServiceVisitMpvi = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit MPVI',
  props<{ businessId: string; dealerCountryCode: string; serviceVisitId: string }>()
);

export const getLinkedServiceVisitMpviError = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit MPVI Error',
  props<{ error: any }>()
);

export const getLinkedServiceVisitMpviSuccess = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit MPVI Success',
  props<{ linkedServiceVisitMpvi: GMServiceVisitVehicleData[] }>()
);

export const getLinkedServiceVisitEcu = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit ECU',
  props<{ businessId: string; dealerCountryCode: string; serviceVisitId: string }>()
);

export const getLinkedServiceVisitEcuError = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit ECU Error',
  props<{ error: any }>()
);

export const getLinkedServiceVisitEcuSuccess = createAction(
  '[svcVehicleDiagnostics] Get Linked Service Visit ECU Success',
  props<{ linkedServiceVisitEcu: GMServiceVisitDtcCount[] }>()
);

export const clearLinkedServiceVisitState = createAction('[svcVehicleDiagnostics] Clear Linked Service Visit State');
export const clearVehicleDiagnosticsState = createAction('[svcVehicleDiagnostics] Clear Vehicle Diagnostics State');

//#endregion
